export enum EProductStockType {
    NONE = 0,
    INCREASE = 1,
    DECREASE = 2,
}

export enum EProductStockKey {
    STOCK_ENABLED = 'stock_tracking_enabled',
    STOCK_DISABLED = 'stock_tracking_disabled',
    NEW_STOCK = 'new_stock',
    REMAKE = 'remake',
    RETURN = 'return',
    TRANSFER = 'transfer',
    ADJUSTMENT = 'adjustment',
    INTERNAL_USE = 'internal_use',
    DAMAGED = 'damaged',
    OUT_OF_DATE = 'out_of_date',
    LOST = 'lost',
    OTHER = 'other',
    SALE = 'sale',
    ITEM_DELETED = 'item_deleted',
    ORDER_REOPEN = 'order_reopen',
    ORDER_CANCELLED = 'order_cancelled',
    ORDER_DELETED = 'order_deleted',
    INVENTORY_ORDER_CANCELLED = 'inventory_order_cancelled',
    INVENTORY_ORDER_DELETED = 'inventory_order_deleted'
}
